import dayjs from "dayjs"

const US_DATE_FORMAT = "MM/DD/YYYY"

const getIsoDateFromDate = date => {
  const [ isoDate ] = date.toISOString().split("T")
  return isoDate
}

const getDateParamsFromDate = date => {
  const isString = typeof date === "string"

  if (isString) {
    date = new Date(date)
  }

  let day = date.getDate()

  if (day < 10) {
    day = `0${day}`
  }

  let month = date.getMonth() + 1

  if (month < 10) {
    month = `0${month}`
  }

  const year = date.getFullYear()

  return [ month, day, year ]
}

const getUsDateFromDate = date => {
  if (!date) {
    return "undefined"
  }

  const [ month, day, year ] = getDateParamsFromDate(date)

  return [ month, day, year ].join('/')
}

const getUsDateFromIsoDate = isoDate => {
  const date = dayjs(isoDate).format('MM/DD/YYYY')

  return date
}

const getIsoDateFromStringDate = date => {
  date = new Date(date)
  const [ month, day, year ] = getDateParamsFromDate(date)

  return [ year, month, day ].join('-')
}

const getCurrencyValue = (value, minimumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits
  })

  const amount = value / 100

  return formatter.format(amount)
}

const getAmountValueFromCurrency = value => value.replace('$', '').replace(/,/g, '')

export {
  getUsDateFromDate,
  getIsoDateFromDate,
  getUsDateFromIsoDate,
  getIsoDateFromStringDate,
  getCurrencyValue,
  getAmountValueFromCurrency,
  US_DATE_FORMAT
}
